import React from 'react'
import { Chart } from "react-google-charts";
import {shadeDefault} from '../InsightsColors';

const InsightPieGraphView =(props)=>{
    const {viewData, activeOption, onSelect} = props;

    const currentOption = activeOption;// || viewData.DefaultOption;
    
    // console.log("layout response view", viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData);

    if(viewData && viewData.ViewData[currentOption] && viewData.ViewData[currentOption].ChartData)
    {
        // const raw = viewData.ViewData[currentOption].ChartData; // first row: ['Label','Value']
        // const total = raw.slice(1).reduce((sum, r) => sum + Number(r[1]), 0);

        const chartData = viewData.ViewData[currentOption].ChartData.map((row, idx) =>
            idx === 0 ? row : [row[0], Number(row[1].toFixed(2))]
        );

        // const chartData = [
        //     raw[0],
        //     ...raw.slice(1).map(r => {
        //         const val = Number(r[1]);
        //         const pct = total ? ((val / total) * 100).toFixed(1) : 0;
        //         return [ r[0], { v: val, f: `${val} (${pct}%)` } ];
        //     })
        // ];

        //console.log("layout response view", viewData.ViewData[currentOption].ChartData);

        const chartEvents = onSelect ? [
            {
                eventName: "select",
                callback: ({ chartWrapper }) => {
                    const chart = chartWrapper.getChart();
                    const selection = chart.getSelection();
                    if (selection.length > 0) {
                        const { row, column } = selection[0];
                        // row: index of the data row (excluding header)
                        // column: index of the data column
                        const dataRow = chartData[row + 1]; // +1 because first row is header
                        const dataColName = chartData[0][column];
                        const value = dataRow ? dataRow[column] : null;
                        // Do something with row, column, value, dataColName, dataRow
                        onSelect({ row, column, value, dataColName, dataRow });
                    }
                }
            }
        ] : [];

        return (
            <Chart
                chartType="PieChart"
                data={chartData}
                options={{
                    bar: { groupWidth: "75%" },
                    legend: { position: "right" },
                    hAxis: { title: viewData.X_AXIS_Title },
                    vAxis: { title: viewData.ViewData[currentOption].Y_AXIS_Title },
                    colors: shadeDefault,
                    is3D: false,
                    pieSliceText: 'percent', // <-- Show value and percent on each slice
                    tooltip: { trigger: 'focus' },        // Show tooltip on hover (default)
                    pieHole: 0,
                    
                    animation: {
                        duration: 1000,
                        easing: "out",
                    },
                    chartArea: {
                        left: 10,
                        top: 10,
                        right: 10,
                        bottom: 10,
                        width: '90%',
                        height: '90%'
                    }
                }}
                chartEvents={chartEvents}
                width="100%"
                height="100%"
            />
        )
    }

    return null;
}

export default InsightPieGraphView
